import React, {useEffect, useState} from 'react';
import {getDataFromCMD} from '../../api/endpoints';
import {post} from '../../api/api';
import AppSpinner from '../../components/app-spinner';
import {compose} from 'redux';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {addToGlobalStyles} from '../../store/actions';
import {pageBackgrounds} from '../../util/colors';

export interface RedirectAppProps {
  addToGlobalStyles(value: any): void;
}
const RedirectApp2 = ({addToGlobalStyles}: RedirectAppProps) => {
  const [userDob, setUserDob] = useState('');
  const [userNif, setUserNif] = useState('');

  useEffect(() => {
    addToGlobalStyles({
      background: pageBackgrounds.homePage,
    });
    verifyCancelledRegisterCMD();
    requestAuthentication();
    sendMessageToAppInScript('211755567', '01-01-2011');
  }, []);

  const sendMessageToAppInScript = (userNif: any, userDob: any) => {
    // Check if the script function exists before calling it
    if ((window as any)?.sendMessageToApp) {
      (window as any).sendMessageToApp(userNif, userDob);
    }
  };

  const verifyCancelledRegisterCMD = () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const error = params.get('error') || '';
    if (error) {
      sendMessageToAppInScript('-1', '-1');
    }
  };

  const requestAuthentication = async () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const accessToken = params.get('access_token');
    const birthdate = 'http://interop.gov.pt/MDC/Cidadao/DataNascimento';
    const nif = 'http://interop.gov.pt/MDC/Cidadao/NIF';

    const body = JSON.stringify({
      token: accessToken,
      attributesName: [birthdate, nif],
    });
    try {
      const response: any = await post(getDataFromCMD(), body);
      if (response) {
        response?.data?.items?.forEach((item: any) => {
          if (item.name === birthdate) {
            setUserDob(item.value);
          } else if (item.name === nif) {
            setUserNif(item.value);
          }
        });
      }
    } catch (error: any) {}
  };

  return (
    <AppSpinner
      style={{
        marginTop: '50%',
        width: 'fit-content',
        justifyContent: 'center',
        alignSelf: 'center',
      }}></AppSpinner>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  withRouter(connect(null, mapDispatchToProps)(RedirectApp2))
);
